import { apiFetch } from "./client.js";

const clientsCache = new Map();

function teamKey(teamId) {
  return teamId || localStorage.getItem("metora_team_id") || "default";
}

export function clearClientsCache(teamId) {
  if (teamId) {
    clientsCache.delete(teamKey(teamId));

    return;
  }

  clientsCache.clear();
}

export function fetchClients(options = {}) {
  const { force = false, ...apiOptions } = options;
  const key = teamKey(apiOptions.teamId);
  const cached = clientsCache.get(key);

  if (!force && cached) {
    return cached;
  }

  const promise = apiFetch("/clients", apiOptions).catch((err) => {
    clientsCache.delete(key);
    throw err;
  });

  clientsCache.set(key, promise);

  return promise;
}
